export const jobs = {
    FINANCE: 'finance',
    RH: 'rh',
    IT: 'it',
    SUPPLYCHAIN: "supplychain",
    SAV: "sav",
};